import Image from 'next/image';

import { styled } from '@mui/material';
import { color } from 'theme.material';
import ListTile from '@/components/ListTile';
import { icons } from './content-tile-icons';

const Title = styled(ListTile.Title)`
  color: ${({ theme }) => theme.palette.text.primary};
`;
const Content = styled(ListTile.Content)`
  background: none;
`;
interface ToolTileProps {
  tool: any;
  bgColor?: string;
  className?: string;
}

function ToolTile({ tool, bgColor, className }: ToolTileProps): JSX.Element {
  const { title, thumbnail, link } = tool ?? {};

  const IconComponent = icons.tools;
  return (
    <a href={link} target="_blank" rel="noreferrer noopener">
      <ListTile bgColor={bgColor} className={className}>
        {thumbnail && (
          <Image
            alt={title}
            unoptimized
            layout="fill"
            src={thumbnail}
            objectFit="contain"
          />
        )}
        <Content>
          <ListTile.TitleContainer>
            <Title>{title}</Title>
            <Title>PDF Download</Title>
          </ListTile.TitleContainer>

          <ListTile.IconContainer>
            <IconComponent />
          </ListTile.IconContainer>
        </Content>
      </ListTile>
    </a>
  );
}
ToolTile.defaultProps = {
  bgColor: color.grey[100],
  className: null,
};

export default ToolTile;
